if (!customElements.get('glow-theme-toggle')) {
  customElements.define(
    'glow-theme-toggle',
    class GlowThemeToggle extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('button');
        this.sync();
        this.button.addEventListener('click', () => this.toggle());
      }

      get isDark() {
        return document.documentElement.getAttribute('data-glow-theme') === 'dark';
      }

      sync() {
        this.button.setAttribute('aria-pressed', this.isDark);
      }

      toggle() {
        const root = document.documentElement;
        const next = this.isDark ? 'light' : 'dark';
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        if (!reduceMotion) {
          root.classList.add('glow-theme-switching');
          clearTimeout(this.timer);
          this.timer = setTimeout(() => root.classList.remove('glow-theme-switching'), 450);
        }

        root.setAttribute('data-glow-theme', next);
        try {
          localStorage.setItem('glow-theme', next);
        } catch (e) {}

        document.querySelectorAll('glow-theme-toggle').forEach((toggle) => toggle.sync());
      }
    }
  );
}
